import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';
export function Login() {
    const { login, register, error, loading } = useAuth();
    const [mode, setMode] = useState('login');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [err, setErr] = useState(null);
    const nav = useNavigate();
    // ?addAccount=1 -- the topbar AccountChip's "Add account" link.
    // When set, the Login page reframes copy to "Add another account"
    // and the post-login redirect still goes to /orgs (the new account
    // sees the org picker fresh; saved accounts stay in localStorage).
    const isAddingAccount = typeof window !== 'undefined'
        && new URLSearchParams(window.location.search).get('addAccount') === '1';
    async function submit(e) {
        e.preventDefault();
        setErr(null);
        try {
            if (mode === 'login') {
                await login(email, password);
            }
            else {
                await register(email, password, name);
            }
            nav('/orgs');
        }
        catch (e2) {
            setErr(e2.message);
        }
    }
    return (_jsx("div", { className: "app-shell", children: _jsxs("div", { className: "center-card", children: [_jsx("h1", { children: isAddingAccount
                        ? 'Add another account'
                        : mode === 'login' ? 'Sign in to FDN' : 'Create a FDN account' }), _jsx("p", { children: isAddingAccount
                        ? 'Sign in as another user. Your existing accounts are kept; switch between them via the avatar in the top-right.'
                        : 'Identity is owned by raindb-app. The same credentials work everywhere.' }), _jsxs("form", { onSubmit: submit, children: [mode === 'register' && (_jsxs(_Fragment, { children: [_jsx("label", { children: "Name" }), _jsx("input", { value: name, onChange: (e) => setName(e.target.value), required: true })] })), _jsx("label", { children: "Email" }), _jsx("input", { type: "email", value: email, onChange: (e) => setEmail(e.target.value), required: true, autoFocus: true }), _jsx("label", { children: "Password" }), _jsx("input", { type: "password", value: password, onChange: (e) => setPassword(e.target.value), required: true }), (err || error) && _jsx("div", { className: "error", children: err || error }), _jsxs("div", { style: { display: 'flex', gap: 8, marginTop: 16 }, children: [_jsx("button", { type: "submit", disabled: loading, children: mode === 'login' ? 'Sign in' : 'Sign up' }), _jsx("button", { type: "button", className: "ghost", onClick: () => setMode(mode === 'login' ? 'register' : 'login'), children: mode === 'login' ? 'or sign up' : 'or sign in' })] })] })] }) }));
}
